import { Grid } from "@mui/material";
import React from "react";
import { ControlText } from "../../helpers";
import { ControlSmallWrapper } from "../../helpers/ControlSmallWrapper";
import { AbmForm } from "../AbmForm";

export const FormConteoPublico = React.forwardRef(({item, schema, onConfirm, onCancel}, ref) => (
  <AbmForm
    ref={ref}
    actionsTop={false}
    actionsBottom={false}
    onSubmit={onConfirm}
    onCancel={onCancel}
    schema={schema}
    item={item}
  >
    {({onControlChange, entity, entityErrors}) => (
      <Grid item xs={12}>
        <ControlText
          name="conteo_publico"
          label="Conteo"
          type="number"
          autoFocus
          errors={entityErrors}
          data={entity}
          onChange={onControlChange}
          Wrapper={ControlSmallWrapper}
          errorPlacement="bottom"
        />
      </Grid>
    )}
  </AbmForm>
));
